import { createContext } from 'react';

export type AlertModalContextType = (text: string) => void;

const AlertModalContext = createContext<AlertModalContextType | null>(
  null,
);

export default AlertModalContext;
